import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Alert, CardBody, Button, Label, Input, FormFeedback, Form } from 'reactstrap';

// Formik Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import withRouter from 'components/Common/withRouter';

//Import Breadcrumb
import Breadcrumb from '../../components/Common/Breadcrumb';

import avatar from '../../assets/images/users/avatar.jpg';
// actions
import {
	changeLayout,
	changeLayoutMode,
	changeSidebarTheme,
	changeTopbarTheme,
	editProfile,
	resetProfileFlag
} from '../../store/actions';
import { changeThemeDataAPI, resetPasswordAPI } from 'store/auth/profile/helper';
import showToastBar from 'components/Common/ShowToast';

const UserProfile = () => {
	//meta title
	document.title = 'Profile | Traxaa';

	const dispatch = useDispatch();

	const [email, setemail] = useState('');
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [idx, setidx] = useState(1);
	const [lastlogin, setLastlogin] = useState('');
	const [isPasswordReseting, setIsPasswordReseting] = useState(false);

	const [getUserPreference, setGetUserPreference] = useState({
		layoutTypes: '',
		layoutModeTypes: '',
		topBarThemeTypes: '',
		verticatlSideBarThemeTypes: ''
	});

	const ProfileProperties = createSelector(
		state => state.Profile,
		profile => ({
			error: profile.error,
			success: profile.success
		})
	);

	const [profilePic, setProfilePic] = useState();
	const { error, success } = useSelector(ProfileProperties);

	useEffect(() => {
		if (localStorage.getItem('authUser')) {
			const obj = JSON.parse(localStorage.getItem('authUser'));
			if (process.env.REACT_APP_DEFAULTAUTH === 'jwt') {
				setFirstName(obj.firstName);
				setLastName(obj.lastName);
				setemail(obj.email);
				setidx(obj.uid);
				setLastlogin(obj.lastlogin);
			}

			if (obj.themeData) {
				setGetUserPreference({
					layoutTypes:
						obj.themeData.layouts != getUserPreference.layoutTypes && getUserPreference.layoutTypes != ''
							? getUserPreference.layoutTypes
							: obj.themeData.layouts,
					layoutModeTypes:
						obj.themeData.layoutMode != getUserPreference.layoutModeTypes && getUserPreference.layoutModeTypes != ''
							? getUserPreference.layoutModeTypes
							: obj.themeData.layoutMode,
					topBarThemeTypes:
						obj.themeData.topBarTheme != getUserPreference.topBarThemeTypes && getUserPreference.topBarThemeTypes != ''
							? getUserPreference.topBarThemeTypes
							: obj.themeData.topBarTheme,
					verticatlSideBarThemeTypes:
						obj.themeData.sidebarTheme != getUserPreference.verticatlSideBarThemeTypes &&
						getUserPreference.verticatlSideBarThemeTypes != ''
							? getUserPreference.verticatlSideBarThemeTypes
							: obj.themeData.sidebarTheme
				});
			}

			setTimeout(() => {
				dispatch(resetProfileFlag());
			}, 3000);
		}
	}, [dispatch, success]);

	useEffect(() => {
		if (getUserPreference.layoutType != '') {
			let getLocalStrogeData = localStorage.getItem('authUser');
			if (getLocalStrogeData) {
				let obj = JSON.parse(getLocalStrogeData);
				obj.themeData.layouts = getUserPreference.layoutTypes;
				localStorage.setItem('authUser', JSON.stringify(obj));
			}
			dispatch(changeLayout(getUserPreference.layoutTypes));
		}
	}, [dispatch, getUserPreference.layoutTypes]);

	useEffect(() => {
		if (getUserPreference.layoutModeTypes != '') {
			let getLocalStrogeData = localStorage.getItem('authUser');
			if (getLocalStrogeData) {
				let obj = JSON.parse(getLocalStrogeData);
				obj.themeData.layoutMode = getUserPreference.layoutModeTypes;
				localStorage.setItem('authUser', JSON.stringify(obj));
			}
			dispatch(changeLayoutMode(getUserPreference.layoutModeTypes));
		}
	}, [dispatch, getUserPreference.layoutModeTypes]);

	useEffect(() => {
		if (getUserPreference.topBarThemeTypes != '') {
			let getLocalStrogeData = localStorage.getItem('authUser');
			if (getLocalStrogeData) {
				let obj = JSON.parse(getLocalStrogeData);
				obj.themeData.topBarTheme = getUserPreference.topBarThemeTypes;
				localStorage.setItem('authUser', JSON.stringify(obj));
			}
			dispatch(changeTopbarTheme(getUserPreference.topBarThemeTypes));
		}
	}, [dispatch, getUserPreference.topBarThemeTypes]);

	useEffect(() => {
		if (getUserPreference.verticatlSideBarThemeTypes != '') {
			let getLocalStrogeData = localStorage.getItem('authUser');
			if (getLocalStrogeData) {
				let obj = JSON.parse(getLocalStrogeData);
				obj.themeData.sidebarTheme = getUserPreference.verticatlSideBarThemeTypes;
				localStorage.setItem('authUser', JSON.stringify(obj));
			}
			dispatch(changeSidebarTheme(getUserPreference.verticatlSideBarThemeTypes));
		}
	}, [dispatch, getUserPreference.verticatlSideBarThemeTypes]);

	const updateUserThemeDataset = async dataValues => {
		await changeThemeDataAPI({
			layouts: dataValues.layoutTypes,
			layoutMode: dataValues.layoutModeTypes,
			topBarTheme: dataValues.topBarThemeTypes,
			sidebarTheme: dataValues.verticatlSideBarThemeTypes
		});
	};

	const validation = useFormik({
		// enableReinitialize : use this flag when initial values needs to be changed
		enableReinitialize: true,

		initialValues: {
			firstName: firstName || '',
			lastName: lastName || '',
			idx: idx || ''
		},
		validationSchema: Yup.object({
			firstName: Yup.string().required('Please Enter Your First Name'),
			lastName: Yup.string().required('Please Enter Your Last Name')
		}),
		onSubmit: values => {
			console.log(values);
			//dispatch(editProfile(values));
		}
	});

	const passwordValidation = useFormik({
		// enableReinitialize : use this flag when initial values needs to be changed
		enableReinitialize: true,

		initialValues: {
			currentPassword: '',
			newPassword: '',
			confirmPassword: ''
		},
		validationSchema: Yup.object({
			currentPassword: Yup.string().required('Please Enter Your Current Password'),
			newPassword: Yup.string().required('Please Enter New Password'),
			confirmPassword: Yup.string().required('Please Confirm Your New Password')
		}),
		onSubmit: values => {
			setIsPasswordReseting(true);
			let inputData = { ...values, email: email };
			resetPasswordAPI(inputData)
				.then(res => {
					setIsPasswordReseting(false);
					showToastBar('Success', res?.message);
					setTimeout(() => {
						passwordValidation.resetForm();
					}, 2000);
				})
				.catch(error => {
					setIsPasswordReseting(false);
					let alertMessage = '';
					if (error.response?.data && error.response?.data?.message) {
						alertMessage = error.response?.data?.message;
					} else {
						alertMessage = 'Failed to reset password. Please try again.';
					}

					showToastBar('Error', alertMessage);
				});
			//dispatch(editProfile(values));
		}
	});

	return (
		<React.Fragment>
			<div className="page-content">
				<Container fluid>
					{/* Render Breadcrumb */}
					<Breadcrumb title="Traxaa" breadcrumbItem="Profile" />

					<Row>
						<Col lg="12">
							{error && error ? <Alert color="danger">{error}</Alert> : null}
							{success ? <Alert color="success">{success}</Alert> : null}

							<Card>
								<CardBody>
									<div className="d-flex">
										<div className="ms-3">
											<img src={avatar} alt="" className="avatar-md rounded-circle img-thumbnail" />
										</div>
										<div className="flex-grow-1 align-self-center">
											<div className="text-muted p-2">
												<h5>
													{firstName} {lastName}
												</h5>
												<p className="mb-1">{email}</p>
												<p className="mb-0">Last Login: {lastlogin}</p>
											</div>
										</div>
									</div>
								</CardBody>
							</Card>
						</Col>
					</Row>
					<Row>
						<Col>
							<h4 className="card-title mb-4">User Prefrences</h4>

							<Card>
								<CardBody>
									{/* Theme Prefrences and booking prefrences */}

									<Row>
										<Col sm="4">
											<div className="mb-4">
												<h5 className="font-size-12">Theme Prefrences</h5>
											</div>
											<Row className="radio-toolbar font-size-10 mt-3">
												<Col sm="3">
													<span className="mb-2 d-block">Layouts</span>
												</Col>
												<Col sm="9">
													<input
														checked={getUserPreference.layoutTypes == 'vertical' ? true : false}
														type="radio"
														id="radioVertical"
														name="layoutTypes"
														value="vertical"
														onClick={e => {
															let previousData = { ...getUserPreference };
															previousData.layoutTypes = 'vertical';
															updateUserThemeDataset({ ...previousData });
															setGetUserPreference({ ...previousData });
														}}
													/>
													<label className="me-1 font-size-10" htmlFor="radioVertical">
														Vertical
													</label>
													<input
														checked={getUserPreference.layoutTypes == 'horizontal' ? true : false}
														type="radio"
														id="radioHorizontal"
														name="layoutTypes"
														value="horizontal"
														onClick={e => {
															updateUserThemeDataset({ ...getUserPreference, layoutTypes: 'horizontal' });
															setGetUserPreference({ ...getUserPreference, layoutTypes: 'horizontal' });
														}}
													/>
													<label htmlFor="radioHorizontal" className="font-size-10">
														{' '}
														Horizontal
													</label>
												</Col>
											</Row>
											<Row className="radio-toolbar font-size-10 mt-3">
												<Col sm="3">
													<span className="mb-2 d-block">Layouts Mode</span>
												</Col>
												<Col sm="9">
													<input
														checked={getUserPreference.layoutModeTypes === 'light' ? true : false}
														type="radio"
														id="radioLight"
														name="radioLayoutMode"
														value="light"
														onClick={e => {
															updateUserThemeDataset({ ...getUserPreference, layoutModeTypes: 'light' });
															setGetUserPreference({ ...getUserPreference, layoutModeTypes: 'light' });
														}}
													/>
													<label className="me-1 font-size-10" htmlFor="radioLight">
														Light
													</label>
													<input
														checked={getUserPreference.layoutModeTypes === 'dark' ? true : false}
														type="radio"
														id="radioDark"
														name="radioLayoutMode"
														value="dark"
														onClick={e => {
															updateUserThemeDataset({ ...getUserPreference, layoutModeTypes: 'dark' });
															setGetUserPreference({ ...getUserPreference, layoutModeTypes: 'dark' });
														}}
													/>
													<label htmlFor="radioDark" className="font-size-10">
														{' '}
														Dark
													</label>
												</Col>
											</Row>
											{getUserPreference.layoutTypes === 'horizontal' ? (
												<Row className="radio-toolbar font-size-10 mt-3">
													<Col sm="3">
														<span className="mb-2 d-block">Topbar Theme</span>
													</Col>
													<Col sm="9">
														<input
															checked={getUserPreference.topBarThemeTypes === 'light' ? true : false}
															type="radio"
															id="radioThemeLight"
															name="radioThemeMode"
															value="light"
															onClick={e => {
																updateUserThemeDataset({ ...getUserPreference, topBarThemeTypes: 'light' });
																setGetUserPreference({ ...getUserPreference, topBarThemeTypes: 'light' });
															}}
														/>
														<label className="me-1 font-size-10" htmlFor="radioThemeLight">
															Light
														</label>
														<input
															checked={getUserPreference.topBarThemeTypes === 'dark' ? true : false}
															type="radio"
															id="radioThemeDark"
															name="radioThemeMode"
															value="dark"
															onClick={e => {
																updateUserThemeDataset({ ...getUserPreference, topBarThemeTypes: 'dark' });
																setGetUserPreference({ ...getUserPreference, topBarThemeTypes: 'dark' });
															}}
														/>
														<label htmlFor="radioThemeDark" className=" me-1 font-size-10">
															{' '}
															Dark
														</label>
														<input
															checked={getUserPreference.topBarThemeTypes === 'colored' ? true : false}
															type="radio"
															id="radioThemeColored"
															name="radioThemeMode"
															value="colored"
															onClick={e => {
																updateUserThemeDataset({ ...getUserPreference, topBarThemeTypes: 'colored' });
																setGetUserPreference({ ...getUserPreference, topBarThemeTypes: 'colored' });
															}}
														/>
														<label htmlFor="radioThemeColored" className=" me-1 font-size-10">
															{' '}
															Colored
														</label>
													</Col>
												</Row>
											) : null}
											{getUserPreference.layoutTypes === 'vertical' && (
												<>
													<Row className="radio-toolbar font-size-10 mt-3">
														<Col sm="3">
															<span className="mb-2 d-block">Left Sidebar Color Theme</span>
														</Col>
														<Col sm="9">
															<input
																checked={getUserPreference.verticatlSideBarThemeTypes === 'light' ? true : false}
																type="radio"
																id="radioSidebarLight"
																name="radioSidebarTheme"
																value="light"
																onClick={e => {
																	updateUserThemeDataset({ ...getUserPreference, verticatlSideBarThemeTypes: 'light' });
																	setGetUserPreference({ ...getUserPreference, verticatlSideBarThemeTypes: 'light' });
																}}
															/>
															<label className="me-1 font-size-10" htmlFor="radioSidebarLight">
																Light
															</label>
															<input
																checked={getUserPreference.verticatlSideBarThemeTypes === 'dark' ? true : false}
																type="radio"
																id="radioSidebarDark"
																name="radioSidebarTheme"
																value="dark"
																onClick={e => {
																	updateUserThemeDataset({ ...getUserPreference, verticatlSideBarThemeTypes: 'dark' });
																	setGetUserPreference({ ...getUserPreference, verticatlSideBarThemeTypes: 'dark' });
																}}
															/>
															<label htmlFor="radioSidebarDark" className=" me-1 font-size-10">
																{' '}
																Dark
															</label>
															<input
																checked={getUserPreference.verticatlSideBarThemeTypes === 'winter' ? true : false}
																type="radio"
																id="radioSidebarWinter"
																name="radioSidebarTheme"
																value="winter"
																onClick={e => {
																	updateUserThemeDataset({
																		...getUserPreference,
																		verticatlSideBarThemeTypes: 'winter'
																	});
																	setGetUserPreference({ ...getUserPreference, verticatlSideBarThemeTypes: 'winter' });
																}}
															/>
															<label htmlFor="radioSidebarWinter" className="me-1 font-size-10">
																{' '}
																Winter
															</label>
															<input
																checked={getUserPreference.verticatlSideBarThemeTypes === 'ladylip' ? true : false}
																type="radio"
																id="radioSidebarLadylip"
																name="radioSidebarTheme"
																value="ladylip"
																onClick={e => {
																	updateUserThemeDataset({
																		...getUserPreference,
																		verticatlSideBarThemeTypes: 'ladylip'
																	});
																	setGetUserPreference({ ...getUserPreference, verticatlSideBarThemeTypes: 'ladylip' });
																}}
															/>
															<label htmlFor="radioSidebarLadylip" className="me-1 font-size-10">
																{' '}
																Ladylip
															</label>
															<input
																checked={getUserPreference.verticatlSideBarThemeTypes === 'plumplate' ? true : false}
																type="radio"
																id="radioSidebarPlumplate"
																name="radioSidebarTheme"
																value="plumplate"
																onClick={e => {
																	updateUserThemeDataset({
																		...getUserPreference,
																		verticatlSideBarThemeTypes: 'plumplate'
																	});
																	setGetUserPreference({
																		...getUserPreference,
																		verticatlSideBarThemeTypes: 'plumplate'
																	});
																}}
															/>
															<label htmlFor="radioSidebarPlumplate" className="me-1 font-size-10">
																{' '}
																Plumplate
															</label>
															<input
																checked={getUserPreference.verticatlSideBarThemeTypes === 'strongbliss' ? true : false}
																type="radio"
																id="radioSidebarStrongbliss"
																name="radioSidebarTheme"
																value="strongbliss"
																onClick={e => {
																	updateUserThemeDataset({
																		...getUserPreference,
																		verticatlSideBarThemeTypes: 'strongbliss'
																	});
																	setGetUserPreference({
																		...getUserPreference,
																		verticatlSideBarThemeTypes: 'strongbliss'
																	});
																}}
															/>
															<label htmlFor="radioSidebarStrongbliss" className="me-1 font-size-10">
																{' '}
																Strongbliss
															</label>
															<input
																checked={getUserPreference.verticatlSideBarThemeTypes === 'greatwhale' ? true : false}
																type="radio"
																id="radioSidebarGreatwhale"
																name="radioSidebarTheme"
																value="greatwhale"
																onClick={e => {
																	updateUserThemeDataset({
																		...getUserPreference,
																		verticatlSideBarThemeTypes: 'greatwhale'
																	});
																	setGetUserPreference({
																		...getUserPreference,
																		verticatlSideBarThemeTypes: 'greatwhale'
																	});
																}}
															/>
															<label htmlFor="radioSidebarGreatwhale" className="me-1 font-size-10">
																{' '}
																Greatwhale
															</label>
														</Col>
													</Row>
													<Row className="radio-toolbar font-size-10 mt-3">
														<Col sm="3">
															<span className="mb-2 d-block">Topbar Theme</span>
														</Col>
														<Col sm="9">
															<input
																checked={getUserPreference.topBarThemeTypes === 'light' ? true : false}
																type="radio"
																id="radioThemeLight"
																name="radioThemeMode"
																value="light"
																onClick={e => {
																	updateUserThemeDataset({ ...getUserPreference, topBarThemeTypes: 'light' });
																	setGetUserPreference({ ...getUserPreference, topBarThemeTypes: 'light' });
																}}
															/>
															<label className="me-1 font-size-10" htmlFor="radioThemeLight">
																Light
															</label>
															<input
																checked={getUserPreference.topBarThemeTypes === 'dark' ? true : false}
																type="radio"
																id="radioThemeDark"
																name="radioThemeMode"
																value="dark"
																onClick={e => {
																	updateUserThemeDataset({ ...getUserPreference, topBarThemeTypes: 'dark' });
																	setGetUserPreference({ ...getUserPreference, topBarThemeTypes: 'dark' });
																}}
															/>
															<label htmlFor="radioThemeDark" className=" me-1 font-size-10">
																{' '}
																Dark
															</label>
															<input
																checked={getUserPreference.topBarThemeTypes === 'colored' ? true : false}
																type="radio"
																id="radioThemeColored"
																name="radioThemeMode"
																value="colored"
																onClick={e => {
																	updateUserThemeDataset({ ...getUserPreference, topBarThemeTypes: 'colored' });
																	setGetUserPreference({ ...getUserPreference, topBarThemeTypes: 'colored' });
																}}
															/>
															<label htmlFor="radioThemeColored" className=" me-1 font-size-10">
																{' '}
																Colored
															</label>
														</Col>
													</Row>
												</>
											)}
											<Row className="radio-toolbar font-size-10 mt-3">
												<Col sm="3">
													<span className="mb-2 d-block">Primary Color</span>
												</Col>
												<Col sm="9">
													<input type="color" value={getUserPreference.primaryColor} />
												</Col>
											</Row>
										</Col>
										<Col sm="4">
											<div className="text-center">
												<h5 className="font-size-12">Booking Prefrences</h5>
											</div>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Col>
					</Row>

					<Row>
						<Col>
							<h4 className="card-title mb-4">Change Profile Info</h4>

							<Card>
								<CardBody>
									<div className="text-center">
										<img id="profilePic" style={{ width: 150, height: 150, borderRadius: 300 }} src={avatar} />
										<Input
											type="file"
											name="profile_pic"
											id="newProfilePhoto"
											accept="image/*"
											style={{ opacity: 0 }}
											onChange={e => {
												console.log(e.target.files[0]);
												setProfilePic(e.target.files[0]);
											}}
										/>
									</div>
									<label htmlFor="newProfilePhoto" className="position-absolute top-0 start-0 end-0 pt-5">
										<div className="text-center">
											<div className="mb-2">
												<i className="fa fa-camera fa-2x"></i>
											</div>
											<div className="text-uppercase">
												Update <br /> Profile Photo
											</div>
										</div>
									</label>

									<Form
										className="form-horizontal"
										onSubmit={e => {
											e.preventDefault();
											validation.handleSubmit();
											return false;
										}}
									>
										<Row className="form-group">
											<Col>
												<Label className="form-label">First Name</Label>
												<Input
													name="firstName"
													// value={name}
													className="form-control"
													placeholder="Enter User Name"
													type="text"
													onChange={validation.handleChange}
													onBlur={validation.handleBlur}
													value={validation.values.firstName || ''}
													invalid={validation.touched.firstName && validation.errors.firstName ? true : false}
												/>
												{validation.touched.firstName && validation.errors.firstName ? (
													<FormFeedback type="invalid">{validation.errors.firstName}</FormFeedback>
												) : null}
												<Input name="idx" value={idx} type="hidden" />
											</Col>
											<Col>
												<Label className="form-label">Last Name</Label>
												<Input
													name="lastName"
													// value={name}
													className="form-control"
													placeholder="Enter User Name"
													type="text"
													onChange={validation.handleChange}
													onBlur={validation.handleBlur}
													value={validation.values.lastName || ''}
													invalid={validation.touched.lastName && validation.errors.lastName ? true : false}
												/>
												{validation.touched.lastName && validation.errors.lastName ? (
													<FormFeedback type="invalid">{validation.errors.lastName}</FormFeedback>
												) : null}
											</Col>
										</Row>
										<div className="text-center mt-4">
											<Button type="submit" color="danger">
												Update
											</Button>
										</div>
									</Form>
								</CardBody>
							</Card>
						</Col>
						<Col>
							<h4 className="card-title mb-4">Change Password</h4>

							<Card>
								<CardBody>
									<Form
										className="form-horizontal"
										onSubmit={e => {
											e.preventDefault();
											passwordValidation.handleSubmit();
											return false;
										}}
									>
										<div className="form-group">
											<Label className="form-label">Current Password</Label>
											<Input
												name="currentPassword"
												// value={name}
												className="form-control"
												placeholder="Enter Current Password"
												type="text"
												onChange={passwordValidation.handleChange}
												onBlur={passwordValidation.handleBlur}
												value={passwordValidation.values.currentPassword || ''}
												invalid={
													passwordValidation.touched.currentPassword && passwordValidation.errors.currentPassword
														? true
														: false
												}
											/>
											{passwordValidation.touched.currentPassword && passwordValidation.errors.currentPassword ? (
												<FormFeedback type="invalid">{passwordValidation.errors.currentPassword}</FormFeedback>
											) : null}

											<Label className="form-label mt-4">New Password</Label>
											<Input
												name="newPassword"
												// value={name}
												className="form-control"
												placeholder="Enter New Password"
												type="password"
												onChange={passwordValidation.handleChange}
												onBlur={passwordValidation.handleBlur}
												value={passwordValidation.values.newPassword || ''}
												invalid={
													passwordValidation.touched.newPassword && passwordValidation.errors.newPassword ? true : false
												}
											/>
											{passwordValidation.touched.newPassword && passwordValidation.errors.newPassword ? (
												<FormFeedback type="invalid">{passwordValidation.errors.newPassword}</FormFeedback>
											) : null}

											<Label className="form-label mt-4">Confirm New Password</Label>
											<Input
												name="confirmPassword"
												// value={name}
												className="form-control"
												placeholder="Confirm New Password"
												type="password"
												onChange={passwordValidation.handleChange}
												onBlur={passwordValidation.handleBlur}
												value={passwordValidation.values.confirmPassword || ''}
												invalid={
													passwordValidation.touched.confirmPassword && passwordValidation.errors.confirmPassword
														? true
														: false
												}
											/>
											{passwordValidation.touched.confirmPassword && passwordValidation.errors.confirmPassword ? (
												<FormFeedback type="invalid">{passwordValidation.errors.confirmPassword}</FormFeedback>
											) : null}
										</div>
										<div className="text-center mt-4">
											{isPasswordReseting ? (
												<Button type="submit" color="danger" disabled>
													Updating...
												</Button>
											) : (
												<Button type="submit" color="danger">
													Update
												</Button>
											)}
										</div>
									</Form>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default withRouter(UserProfile);
